import { lazy } from "react";
import Loadable from "app/components/Loadable";

const WorkflowStageForm = Loadable(lazy(() => import("./StageFormRenderer")));

const WorkflowStageRoutes = [
  { path: "/workflow/stage/configuration", element: <WorkflowStageForm /> },
];

export default WorkflowStageRoutes;
